import React, { useState, useEffect, Component, Fragment } from "react";

import { useTranslation, I18nextProvider } from "react-i18next";
import { Route, Link, BrowserRouter as Router, useLocation } from "react-router-dom";


import casino from '../assets/images/casino.png';
import sports from '../assets/images/sports.png';
import home from '../assets/images/menu-icons/home.svg';
import games from '../assets/images/menu-icons/games.svg';
import deposit from '../assets/images/menu-icons/deposit.svg';
import withdraw from '../assets/images/menu-icons/withdraw.svg';
import kyc from '../assets/images/menu-icons/kyc.svg';
import transaction from '../assets/images/menu-icons/transaction.svg';
import statics from '../assets/images/menu-icons/statics.svg';
import livecasino from '../assets/images/menu-icons/livecasino.svg';
import lottery from '../assets/images/menu-icons/lottery.svg';
import promotions from '../assets/images/menu-icons/promotions.svg';
import affiliate from '../assets/images/menu-icons/affiliate.svg';
import vip from '../assets/images/menu-icons/vip.svg';
import fourm from '../assets/images/menu-icons/fourm.svg';
import favgame from '../assets/images/menu-icons/favgame.svg';
import recplay from '../assets/images/menu-icons/recplay.svg';
import contact from '../assets/images/menu-icons/contact.svg';


import { useCustomizeContext } from "../context";
import { useDispatch, useSelector } from "react-redux";
import { getUserDetails } from "../Features/SiteSettings/siteSettingSlice";

import { useNavigate } from "react-router";
import { getWalletBalance } from "../Features/WalletDetails/walletBalanceSlice";


import 'react-loading-skeleton/dist/skeleton.css'

import { addNewUser, login, logout } from "../Features/Register/registerSlice";

import { getSearchGames } from "../../src/Features/GameCommon/gameCommonSlice";


const Sidebar = (props) => {
   const { t, i18n } = useTranslation();

   const location = useLocation();
   const [locationpath, setLocationpath] = useState(location?.pathname);



   let dispatch = useDispatch();

   let navigate = useNavigate();



   const {
      loader: { loading, setLoading },
      modelStatus: {
         modal,
         setModal,
         modal1,
         setModal1,
         modal2,
         setModal2,
         modal3,
         setModal3,
         modal4,
         setModal4,
      },
      userAuthToken: { userToken, setUserToken },
      forget: { forgetCode },
      siteInformation: { favicon, logo, darkThemeLogo },
      bet: { selectedCurrency, setSelectedCurrency, balance, setBalance, selectCurrency, setSelectCurrency, brlbal, setBrlbal },
      apiResponses: {
         updateRes,
      },
      theme: {
         lightThemeIsActive, setLightThemeIsActive
      },
      languageContext: {
         language, setLanguage,
         changeLanguageRes, setChangeLanguageRes,
      },
      userInfo: {
         userName, setUserName, profile, setProfile,
      },
      mineGameMode: {
         mineMode, setMineMode,
      },
      categoryMode: {
         isActive, setIsActive
      },
      gameSearch: {
         searchGameRes, setGameSearchRes,
         searchIsActive, setSearchIsActive,
         searchText, setSearchText,
      },
      sideMenu: {
         classIsActive, setClassIsActive,
         isOpen, setSideMenuOpen
      },
   } = useCustomizeContext();

   const withdrawres = useSelector((state) => state?.bankdata?.AddWithdrawres)

   const depositres = useSelector((state) => state?.bankdata?.AddDepositres)




   const togglePopLogin = () => {
      setModal(!modal);
      setModal1(false);
      setModal2(false);
      setModal3(false);
      setModal4(false);
   };

   const togglePopRegister = () => {
      setModal2(!modal2);
      setModal1(false);
      setModal(false);
      setModal3(false);
      setModal4(false);
   };

   const getCurrency = (id) => {
      if (id) {
         let find = selectedCurrency?.filter((temp) => temp?.cid === id);
         setSelectCurrency(find[0]);
         setBalance(find[0].originalBal?.toFixed(2));
      }
   }

   useEffect(() => {
      if (userToken) {
         getBalance();
         getuserProfile();
      }
   }, [userToken, updateRes, changeLanguageRes, withdrawres, depositres]);


   const getuserProfile = async () => {
      if (mineMode === "manual") {
         setLoading(true);
      }
      let res = await dispatch(getUserDetails());
      setTimeout(() => {
         if (res?.status) {
            setProfile(res?.data?.details?.profile_picture);
            // document
            //    .getElementById("userImg")
            //    .setAttribute("src", res?.data?.details?.profile_picture);
            setUserName(res?.data?.details?.username);
            setLoading(false);
         } else {
            setLoading(false);
         }
      }, 500);
   };


   const getBalance = async () => {
      if (mineMode === "manual") {
         setLoading(true);
      }
      let res = await dispatch(getWalletBalance());
      setTimeout(() => {
         if (res?.status === true) {
            setSelectedCurrency(res?.data);

            if (selectCurrency) {



               setBrlbal(res?.data[0]?.originalBal)
               res?.data?.map((temp) => {
                  if (temp?.symbol === selectCurrency?.symbol) {
                     setSelectCurrency(temp);
                     setBalance(temp?.originalBal?.toFixed(2));
                  }
               })
            }
            else {
               setSelectCurrency(res?.data[0]);
               setBalance(res?.data[0]?.originalBal?.toFixed(2));
            }
            setLoading(false);
         } else {
            setLoading(false);
         }
      }, 500);
   };

   const logoutUser = async () => {
      setLoading(true);
      let res = await dispatch(logout());
      setLoading(true);
      setTimeout(() => {
         if (res?.status) {
            localStorage.removeItem("loginToken");
            setUserToken("");
            setUserName("");
            navigate("/");
            setLoading(false);
         } else {
            setLoading(false);
         }
      }, 500);
   };


   //  Get All Games Search Function

   useEffect(() => {
      let data = {
         gamename: ""
      }
      searchGame(data);
   }, []);


   const getSearchFunction = async (event) => {
      setSearchText(event.target.value);
      if (event.target.value?.length >= 3) {
         let data = {
            gamename: event?.target?.value
         }
         searchGame(data);
      }
      else if (event.target.value === "") {
         let data = {
            gamename: event?.target?.value
         }
         searchGame(data);
      }
   }

   const searchGame = async (data) => {
      let gameRes = await dispatch(getSearchGames(data));
      if (gameRes?.status) {
         setGameSearchRes(gameRes?.data);
      }
      else {
         setGameSearchRes([])
      }
   }


   const clearSearch = async () => {
      setSearchIsActive(false);
      setSearchText("");
      let data = {
         gamename: ""
      }
      searchGame(data);
   }


   const navigateRoutePage = (path) => {
      navigate("/deposit");
   }


   return (
      <Fragment>
         <div class="sidebarnew-main cus-scroll">
            <div class="headermenu-cnt mt-3 d-lg-none">
               <div class="header-menucntOne">
                  <div class="casinosports-box">
                     <Link to="/" class={isActive ? "" : "active"} onClick={() => { setIsActive(false); navigate("/") }}>
                        <div class="casino-grid casino-a">
                           <div class="d-flex"> <img src={casino} alt="" class="img-fluid" /> </div>
                           <div class="ml-2">
                              <h5>{t("Casino")}</h5>
                           </div>
                        </div>
                     </Link>
                     <Link to="/comingsoon" class={isActive ? "active" : ""} onClick={() => { setIsActive(true); navigate("/comingsoon") }}>
                        <div class="casino-grid sports-a">
                           <div class="d-flex"> <img src={sports} alt="" class="img-fluid" /> </div>
                           <div class="ml-2">
                              <h5>{t("Sports")}</h5>
                           </div>
                        </div>
                     </Link>
                  </div>
                  <div class="header-search mt-3">
                     <input type="text" name="" id="" value={searchText} onChange={(event) => getSearchFunction(event)} onFocus={() => setSearchIsActive(true)} placeholder={`${t('Game Name')} | ${t('Provider')} | ${t('Category Tag')}`} />
                     {
                        searchIsActive ?
                           <a><span class="searchGames_CloseIcon" onClick={clearSearch}>X</span></a>
                           :
                           <a>
                              <svg width="15" height="14" viewBox="0 0 15 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                 <path fill-rule="evenodd" clip-rule="evenodd" d="M6.9899 0C10.7622 0 13.8307 2.95111 13.8307 6.57919C13.8307 8.2909 13.1476 9.85208 12.03 11.0238L14.2292 13.1345C14.4351 13.3325 14.4358 13.6527 14.2299 13.8507C14.1274 13.9507 13.9918 14 13.8569 14C13.7228 14 13.5879 13.9507 13.4846 13.852L11.2588 11.7173C10.0879 12.6191 8.60327 13.1591 6.9899 13.1591C3.21758 13.1591 0.148438 10.2073 0.148438 6.57919C0.148438 2.95111 3.21758 0 6.9899 0ZM6.9899 1.01343C3.79853 1.01343 1.20216 3.50985 1.20216 6.57919C1.20216 9.64853 3.79853 12.1456 6.9899 12.1456C10.1806 12.1456 12.7769 9.64853 12.7769 6.57919C12.7769 3.50985 10.1806 1.01343 6.9899 1.01343Z" fill="white" />
                              </svg>
                           </a>
                     }
                  </div>
               </div>
               {/* <div class="header-menucntTwo mt-3 d-md-none">
                  <div className="header-InrMenu">
                     <div class="loginreg-menu">
                        {
                           userToken === "" ||
                              userToken === undefined ||
                              userToken === null ?
                              <>
                                 <Link class="login-menu mt-3" onClick={togglePopLogin}>{t("Login")}</Link>
                                 <Link class="reg-menu mt-3" onClick={togglePopRegister}>{t("Register")}</Link>
                              </>
                              :
                              null
                        }
                     </div>
                  </div>
               </div> */}
            </div>
            <ul class="sidebar-mainul cus-scroll">
               <li>
                  <Link to="/">
                     <div class="sidemenu-grid">
                        <div class="sidemenu-icon">
                           <img src={home} alt="" class="img-fluid" />
                        </div>
                        <div class="sidemenu-txt">
                           <h5>{t("Home")}</h5>
                        </div>
                     </div>
                  </Link>
               </li>
               <li>
                  <Link to="/">
                     <div class="sidemenu-grid">
                        <div class="sidemenu-icon">
                           <img src={games} alt="" class="img-fluid" />
                        </div>
                        <div class="sidemenu-txt">
                           <h5>{t("Games")}</h5>
                        </div>
                     </div>
                  </Link>
               </li>

               <li>
                  <Link to={userToken ? "/deposit" : "/"} onClick={userToken ? "" : () => setModal(!modal)}>
                     <div class="sidemenu-grid">
                        <div class="sidemenu-icon">
                           <img src={deposit} alt="" class="img-fluid" />
                        </div>
                        <div class="sidemenu-txt">
                           <h5>{t("Deposit")}</h5>
                        </div>
                     </div>
                  </Link>
               </li>
               <li>
                  <Link to={userToken ? "/withdraw" : "/"} onClick={userToken ? "" : () => setModal(!modal)}>
                     <div class="sidemenu-grid">
                        <div class="sidemenu-icon">
                           <img src={withdraw} alt="" class="img-fluid" />
                        </div>
                        <div class="sidemenu-txt">
                           <h5>{t("Withdraw")}</h5>
                        </div>
                     </div>
                  </Link>
               </li>

               <li>
                  <Link to={userToken ? "/kyc" : "/"} onClick={userToken ? "" : () => setModal(!modal)}>
                     <div class="sidemenu-grid">
                        <div class="sidemenu-icon">
                           <img src={kyc} alt="" class="img-fluid" />
                        </div>
                        <div class="sidemenu-txt">
                           <h5>{t("KYC")}</h5>
                        </div>
                     </div>
                  </Link>
               </li>
               <li>
                  <Link to={userToken ? "/transaction" : "/"} onClick={userToken ? "" : () => setModal(!modal)}>
                     <div class="sidemenu-grid">
                        <div class="sidemenu-icon">
                           <img src={transaction} alt="" class="img-fluid" />
                        </div>
                        <div class="sidemenu-txt">
                           <h5>{t("Transaction")}</h5>
                        </div>
                     </div>
                  </Link>
               </li>
               <li>
                  <Link to={userToken ? "/statistics" : "/"} onClick={userToken ? "" : () => setModal(!modal)}>
                     <div class="sidemenu-grid">
                        <div class="sidemenu-icon">
                           <img src={statics} alt="" class="img-fluid" />
                        </div>
                        <div class="sidemenu-txt">
                           <h5>{t("Statistics")}</h5>
                        </div>
                     </div>
                  </Link>
               </li>
               <li>
                  <Link to="/comingsoon">
                     <div class="sidemenu-grid">
                        <div class="sidemenu-icon">
                           <img src={livecasino} alt="" class="img-fluid" />
                        </div>
                        <div class="sidemenu-txt">
                           <h5>{t("Live Casino")}</h5>
                        </div>
                     </div>
                  </Link>
               </li>
               <li>
                  <Link to="/comingsoon">
                     <div class="sidemenu-grid">
                        <div class="sidemenu-icon">
                           <img src={lottery} alt="" class="img-fluid" />
                        </div>
                        <div class="sidemenu-txt">
                           <h5>{t("Lottery")}</h5>
                        </div>
                     </div>
                  </Link>
               </li>
               <li>
                  <Link to="/comingsoon">
                     <div class="sidemenu-grid">
                        <div class="sidemenu-icon">
                           <img src={promotions} alt="" class="img-fluid" />
                        </div>
                        <div class="sidemenu-txt">
                           <h5>{t("Promotions")}</h5>
                        </div>
                     </div>
                  </Link>
               </li>
               <li>
                  <Link to="/comingsoon">
                     <div class="sidemenu-grid">
                        <div class="sidemenu-icon">
                           <img src={affiliate} alt="" class="img-fluid" />
                        </div>
                        <div class="sidemenu-txt">
                           <h5>{t("Affiliate")}</h5>
                        </div>
                     </div>
                  </Link>
               </li>
               <li>
                  <Link to="/comingsoon">
                     <div class="sidemenu-grid">
                        <div class="sidemenu-icon">
                           <img src={vip} alt="" class="img-fluid" />
                        </div>
                        <div class="sidemenu-txt">
                           <h5>{t("VIP Club")}</h5>
                        </div>
                     </div>
                  </Link>
               </li>
               <li>
                  <Link to="/comingsoon">
                     <div class="sidemenu-grid">
                        <div class="sidemenu-icon">
                           <img src={fourm} alt="" class="img-fluid" />
                        </div>
                        <div class="sidemenu-txt">
                           <h5>{t("Forum")}</h5>
                        </div>
                     </div>
                  </Link>
               </li>
               <li>
                  <Link to="/comingsoon">
                     <div class="sidemenu-grid">
                        <div class="sidemenu-icon">
                           <img src={favgame} alt="" class="img-fluid" />
                        </div>
                        <div class="sidemenu-txt">
                           <h5>{t("Favourite Game")}</h5>
                        </div>
                     </div>
                  </Link>
               </li>
               <li>
                  <Link to="/comingsoon">
                     <div class="sidemenu-grid">
                        <div class="sidemenu-icon">
                           <img src={recplay} alt="" class="img-fluid" />
                        </div>
                        <div class="sidemenu-txt">
                           <h5>{t("My Recent Play")}</h5>
                        </div>
                     </div>
                  </Link>
               </li>
               <li>
                  <Link to="/contactus">
                     <div class="sidemenu-grid">
                        <div class="sidemenu-icon">
                           <img src={contact} alt="" class="img-fluid" />
                        </div>
                        <div class="sidemenu-txt">
                           <h5>{t("Contact Us")}</h5>
                        </div>
                     </div>
                  </Link>
               </li>
            </ul>
         </div>
      </Fragment>
   );

}

export default Sidebar;

